export const OracleKeywords: string[] = [];
